export default "__VITE_ASSET__CNSrPXd7__"